export enum PickrMode {
  List = "list",
  Groups = "groups",
  Amount = "amount",
}
